/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutboundPlanListReqVo
 */
export interface OutboundPlanListReqVo {
    /**
     * 仓库id
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    warehouseId?: number;
    /**
     * 客户端查询混合运输方式
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    mixedTransportationId?: number;
    /**
     * 服务类型 1 海外直购， 2 橙火入仓服务， 3 3pl
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    requestGroup?: number;
    /**
     * 订单状态
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    orderStatus?: number;
    /**
     * 申请类别
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    requestType?: number;
    /**
     * 国际运输方式id
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    internationalTransportMethodId?: number;
    /**
     * 出库运单号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    ivc?: string;
    /**
     * 市场条码
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    marketBarcode?: string;
    /**
     * 唛头号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    markNo?: string;
    /**
     * 用户编号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    userCode?: string;
    /**
     * 用户名
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    userAccount?: string;
    /**
     * 订单编号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    orderCode?: string;
    /**
     * coupang预约id
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    coupangBookingId?: string;
    /**
     * coupang入仓开始时间
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    coupangWarehouseBeginTime?: string;
    /**
     * coupang入仓结束时间
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    coupangWarehouseEndTime?: string;
    /**
     * 账单状态
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    billStatus?: number;
    /**
     * 工作人员姓名
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    workerName?: string;
    /**
     * 通关方式 1 企业 2 个人
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    ctmsType?: number;
    /**
     * 收件人姓名
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    receiverName?: string;
    /**
     * 从韩国仓库入库证编码
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    trunkWarehouseCode?: string;
    /**
     * 从韩国仓库下单时的入库证编码
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    koreaWarehouseCode?: string;
    /**
     * 订单创建时间开始
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    orderCreateBeginTime?: string;
    /**
     * 订单创建时间结束
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    orderCreateEndTime?: string;
    /**
     * 商品编号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    goodsCode?: string;
    /**
     * 商品SKU编号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    skuCode?: string;
    /**
     * 中国电商购物平台的订单编号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    platformOrderCode?: string;
    /**
     * 中国快递运单号
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    trackNo?: string;
    /**
     * 出库日期 yyyy-MM-dd
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    outboundDate?: string;
    /**
     * 出库计划开始日期 yyyy-MM-dd
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    outboundDateBegin?: string;
    /**
     * 出库计划结束日期 yyyy-MM-dd
     * @type {string}
     * @memberof OutboundPlanListReqVo
     */
    outboundDateEnd?: string;
    /**
     * 订单id列表 给出库计划查询用的
     * @type {Array<number>}
     * @memberof OutboundPlanListReqVo
     */
    orderIds?: Array<number>;
    /**
     * 出库计划状态 1 进行中 2 已完成
     * @type {number}
     * @memberof OutboundPlanListReqVo
     */
    outboundStatus?: number;
}

/**
 * Check if a given object implements the OutboundPlanListReqVo interface.
 */
export function instanceOfOutboundPlanListReqVo(value: object): value is OutboundPlanListReqVo {
    return true;
}

export function OutboundPlanListReqVoFromJSON(json: any): OutboundPlanListReqVo {
    return OutboundPlanListReqVoFromJSONTyped(json, false);
}

export function OutboundPlanListReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundPlanListReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'mixedTransportationId': json['mixedTransportationId'] == null ? undefined : json['mixedTransportationId'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userAccount': json['userAccount'] == null ? undefined : json['userAccount'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'coupangBookingId': json['coupangBookingId'] == null ? undefined : json['coupangBookingId'],
        'coupangWarehouseBeginTime': json['coupangWarehouseBeginTime'] == null ? undefined : json['coupangWarehouseBeginTime'],
        'coupangWarehouseEndTime': json['coupangWarehouseEndTime'] == null ? undefined : json['coupangWarehouseEndTime'],
        'billStatus': json['billStatus'] == null ? undefined : json['billStatus'],
        'workerName': json['workerName'] == null ? undefined : json['workerName'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'trunkWarehouseCode': json['trunkWarehouseCode'] == null ? undefined : json['trunkWarehouseCode'],
        'koreaWarehouseCode': json['koreaWarehouseCode'] == null ? undefined : json['koreaWarehouseCode'],
        'orderCreateBeginTime': json['orderCreateBeginTime'] == null ? undefined : json['orderCreateBeginTime'],
        'orderCreateEndTime': json['orderCreateEndTime'] == null ? undefined : json['orderCreateEndTime'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'platformOrderCode': json['platformOrderCode'] == null ? undefined : json['platformOrderCode'],
        'trackNo': json['trackNo'] == null ? undefined : json['trackNo'],
        'outboundDate': json['outboundDate'] == null ? undefined : json['outboundDate'],
        'outboundDateBegin': json['outboundDateBegin'] == null ? undefined : json['outboundDateBegin'],
        'outboundDateEnd': json['outboundDateEnd'] == null ? undefined : json['outboundDateEnd'],
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
        'outboundStatus': json['outboundStatus'] == null ? undefined : json['outboundStatus'],
    };
}

export function OutboundPlanListReqVoToJSON(json: any): OutboundPlanListReqVo {
    return OutboundPlanListReqVoToJSONTyped(json, false);
}

export function OutboundPlanListReqVoToJSONTyped(value?: OutboundPlanListReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'mixedTransportationId': value['mixedTransportationId'],
        'requestGroup': value['requestGroup'],
        'orderStatus': value['orderStatus'],
        'requestType': value['requestType'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'ivc': value['ivc'],
        'marketBarcode': value['marketBarcode'],
        'markNo': value['markNo'],
        'userCode': value['userCode'],
        'userAccount': value['userAccount'],
        'orderCode': value['orderCode'],
        'coupangBookingId': value['coupangBookingId'],
        'coupangWarehouseBeginTime': value['coupangWarehouseBeginTime'],
        'coupangWarehouseEndTime': value['coupangWarehouseEndTime'],
        'billStatus': value['billStatus'],
        'workerName': value['workerName'],
        'ctmsType': value['ctmsType'],
        'receiverName': value['receiverName'],
        'trunkWarehouseCode': value['trunkWarehouseCode'],
        'koreaWarehouseCode': value['koreaWarehouseCode'],
        'orderCreateBeginTime': value['orderCreateBeginTime'],
        'orderCreateEndTime': value['orderCreateEndTime'],
        'goodsCode': value['goodsCode'],
        'skuCode': value['skuCode'],
        'platformOrderCode': value['platformOrderCode'],
        'trackNo': value['trackNo'],
        'outboundDate': value['outboundDate'],
        'outboundDateBegin': value['outboundDateBegin'],
        'outboundDateEnd': value['outboundDateEnd'],
        'orderIds': value['orderIds'],
        'outboundStatus': value['outboundStatus'],
    };
}

